import {
	MeetingPageUrl, SymposiaPageUrl, SymposiaProposalPageUrl,
	SymposiaWorkshopPageUrl, SearchKeywordPageUrl,MyAgendadPageUrl,MyMeetingMaterialPageUrl, MySchedulePageUrl
} from './page.url'

export const breadcrumbArray = [
	{
		url: MeetingPageUrl,
		content: [{ title: 'Get Involved', url: '#' }, { title: 'Meetings & Symposia', url: '' }],
		header: 'Meetings, Symposia and Workshops'
	},
	{
		url: SymposiaPageUrl,
		content: [{ title: 'Get Involved', url: '#' }, { title: 'Meetings & Symposia', url: `${MeetingPageUrl}` }, { title: 'All Events', url: '' }],
		header: 'All Events'
	},
	{
		url: SymposiaProposalPageUrl,
		content: [{ title: 'Get Involved', url: '#' }, { title: 'Meetings & Symposia', url: `${MeetingPageUrl}` }, { title: 'Proposal for Symposium', url: '' }],
		header: 'Proposal for Symposium / Workshop / Conference / Seminar'
	},
	{
		url: SymposiaWorkshopPageUrl,
		content: [{ title: 'Get Involved', url: '#' }, { title: 'Meetings & Symposia', url: `${MeetingPageUrl}` }, { title: 'Symposia & Workshops', url: '' }],
		header: 'Symposia & Workshops'
	},
	{
		url: SearchKeywordPageUrl,
		content: [{ title: 'Get Involved', url: '#' }, { title: 'Meetings & Symposia', url: `${MeetingPageUrl}` }, { title: 'Search by Keyword', url: '' }],
		header: 'Search by Keyword'
	},
	{
		url:MyAgendadPageUrl,
		content: [{ title: 'MyASTM', url: '' }, { title: 'Membership', url: 'MyASTM' },{ title: 'MyCommittees', url: 'MyASTM/MyCommittees' }, { title: 'MyAgenda', url: '' }],
		header: 'Create MyAgenda'
	},
	{
		url:MyMeetingMaterialPageUrl,
		content: [{ title: 'MyASTM', url: '' }, { title: 'Membership', url: 'MyASTM' },{ title: 'MyCommittees', url: 'MyASTM/MyCommittees' }, { title: 'MyMeeting Materials', url: '' }],
		header: 'Create MyAgenda'
	},
	{
		url:MySchedulePageUrl,
		content: [{ title: 'MyASTM', url: '' }, { title: 'Membership', url: 'MyASTM' },{ title: 'MyCommittees', url: 'MyASTM/MyCommittees' }, { title: 'MySchedule', url: '' }],
		header: 'Create MySchedule'
	}
]
